import React from "react";
import { FontIcon } from "@fluentui/react";
import { mergeStyles } from "@fluentui/merge-styles";
import { WORKSPACE_ICON_COLOR } from "../../../../config/colors";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useMount } from "react-use";

type Props = {
  workspaceName: string;
};

const wrapperClasses = mergeStyles({
  padding: 10,
  display: "flex",
});

const asideClasses = mergeStyles({
  width: 30,
  flexShrink: 0,
});

const bodyClasses = mergeStyles({});

const iconClass = mergeStyles({
  fontSize: 20,
  color: WORKSPACE_ICON_COLOR,
});

const Workspace: React.FC<Props> = (props) => {
  const { workspaceName } = props;

  const appInsights = useAppInsightsContext();

  useMount(() => {
    appInsights.trackPageView({ name: "Attachments summary" });
  });

  return (
    <div className={wrapperClasses}>
      <div className={asideClasses}>
        <FontIcon aria-label="Work" iconName="Work" className={iconClass} />
      </div>
      <div className={bodyClasses}>{workspaceName}</div>
    </div>
  );
};

export default Workspace;
